import clsx from 'clsx'
import styles from './styles.module.scss'

function ImageMessage({ renderRepliedMsgPreview, title, url, alt = '', className, type }) {
  return (
    <div data-type={type} className={clsx(styles.img_message, className)}>
      {renderRepliedMsgPreview}
      <div className={styles.img_container}>
        <a title={title} className={styles.link} target="blank" href={url}>
          <img src={url} alt={alt} width={100} height={50} />
        </a>
      </div>
    </div>
  )
}

export default ImageMessage
